import React, { ComponentProps } from 'react'
import LoyaltyTierPill from './LoyaltyTierPill'
import LoyaltyBenefitIcon from './LoyaltyBenefitIcon'

type InheritedLoyaltyTierPillProps = Omit<ComponentProps<typeof LoyaltyTierPill>, 'icon'>

interface Props extends InheritedLoyaltyTierPillProps {
  benefitType: App.LoyaltyBenefitType
}

function LoyaltyTierBenefitPill({
  benefitType,
  ...rest
}: Props) {
  return <LoyaltyTierPill {...rest} icon={<LoyaltyBenefitIcon benefitType={benefitType} />} />
}

export default LoyaltyTierBenefitPill
